'use strict';

var data,
    prevData,
    height = 0,
    counter = 0,
    dataCount = 0;

$(document).ready(function () {

	if ($('[data-component="highlights"]').length > 0) {
		var highlights = new Highlights();
	}

	if ($('[data-component="bank-features"]').length > 0) {
		var bankFeatures = new BankFeatures();
	}

	if ($('[data-component="highlight-carrousel"]').length > 0) {
		var highlightCarrousel = new HighlightCarrousel();
	}

	if ($('[data-component="news"]').length > 0) {
		var news = new News();
	}

	if ($('[data-component="how-to-invest"]').length > 0) {
		var howToInvest = new HowToInvest();
	}

	if ($('[data-component="article-slider"]').length > 0) {
		var slider = new Slider();
	}

	if ($('[data-component="gallery"]').length > 0) {
		var gallery = new Gallery();
	}

	if ($('[data-component="header"]').length > 0) {
		var header = new Header();
	}

	if ($('[data-component="subhead"]').length > 0) {
		var subhead = new Subhead();
	}

	if ($('[data-component="faq-item"]').length > 0) {
		var faqItem = new FaqItem();
	}

	if ($('[data-component="faq-options"]').length > 0) {
		var faqOptions = new FaqOptions();
	}

	if ($('[data-component="video"]').length > 0) {
		var video = new Video();
	}

	if ($('[data-component="register"]').length > 0) {
		var register = new Register();
	}

	if ($('[data-component="accounts"]').length > 0) {
		var accounts = new Accounts();
	}

	if ($('[data-component="tabs"]').length > 0) {
		var tabs = new Tabs();
	}

	if ($('[data-component="tabs-commercial"]').length > 0) {
		var tabsCommercial = new TabsCommercial();
	}

	if ($('[data-component="table-modal"]').length > 0) {
		var tableModal = new TableModal();
	}

	if ($('[data-component="timeline"]').length > 0) {
		var timeline = new Timeline();
	}

	if ($('[data-component="main-search"]').length > 0) {
		var mainSearch = new MainSearch();
	}

	if ($('[data-component="states"]').length > 0) {
		var offices = new Offices();
	}

	if ($('[data-component="graphics"]').length > 0) {
		var graphics = new Graphics();
	}

	if ($('[data-component="transitions"]').length > 0) {
		var transition = new Transition();
	}

	if ($('[data-component="ranking"]').length > 0) {
		var ranking = new Ranking();
	}

	if ($('[data-component="receive-email"]').length > 0) {
		var receiveEmail = new ReceiveEmail();
	}

	if ($('[data-component="form"]').length > 0) {

		$('[data-component="form"]').each(function () {

			var $self = $(this).find('form');
			var form = new Form($self);
		});
	}

	if ($('[data-component="message"]').length > 0) {

		$('[data-component="message"]').each(function () {

			var $self = $(this).find('form');
			var form = new Message($self);
		});
	}

	$('.back-top').on('click', function (e) {
		e.preventDefault();

		$('html, body').animate({
			scrollTop: 0
		}, 700);
	});

	if ($('[data-equalizer]').length) {
		if ($(window).width() >= 768) {
			$('[data-equalizer]').each(function (e) {
				if ($(this).find('[data-component="cities"]').length > 0) {
					if ($(window).width() > 1024) {
						data = $(this).attr('data-equalizer');
						if (counter < 1) {
							prevData = data;
							counter++;
						}
						if (data === prevData) {
							dataCount++;
							calculateHeight($(this), data);
						} else {
							counter = 0;
							height = 0;
							prevData = '';
							calculateHeight($(this), data);
						}
						if (dataCount === $('[data-equalizer="' + data + '"]').length) {
							$('[data-equalizer="' + data + '"] > div').height(height);
							// dataCount = 0;
						}
					}
				} else {
					data = $(this).attr('data-equalizer');
					if (counter < 1) {
						prevData = data;
						counter++;
					}
					if (data === prevData) {
						dataCount++;
						calculateHeight($(this), data);
					} else {
						counter = 0;
						height = 0;
						prevData = '';
						calculateHeight($(this), data);
					}
					if (dataCount === $('[data-equalizer="' + data + '"]').length) {
						$('[data-equalizer="' + data + '"] > div').height(height);
						// dataCount = 0;
					}
				}
			});
		}
	}

	$('img.svg').each(function () {
		var $img = $(this);
		var imgID = $img.attr('id');
		var imgClass = $img.attr('class');
		var imgURL = $img.attr('src');

		$.get(imgURL, function (data) {
			// Get the SVG tag, ignore the rest
			var $svg = $(data).find('svg');

			// Add replaced image's ID to the new SVG
			if (typeof imgID !== 'undefined') {
				$svg = $svg.attr('id', imgID);
			}
			// Add replaced image's classes to the new SVG
			if (typeof imgClass !== 'undefined') {
				$svg = $svg.attr('class', imgClass + ' replaced-svg');
			}

			// Remove any invalid XML tags as per http://validator.w3.org
			$svg = $svg.removeAttr('xmlns:a');

			// Check if the viewport is set, else we gonna set it if we can.
			if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
				$svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'));
			}

			// Replace image with new SVG
			$img.replaceWith($svg);
		}, 'xml');
	});

	$('.phone').mask('(00) 00000-0000');
	$('.date').mask('00/00/0000');

	$('span.Botao').each(function () {
		$(this).find('a').append('<i class="icon-arrow-right-white"></i>');
	});
});

function calculateHeight(item, data) {

	if (item.height() > height) {
		height = item.outerHeight();
	}
}
'use strict';

var Slider = function Slider() {

	this.init = function () {

		this.slider();
	};

	if ($(window).width() < 768) {

		$("[data-component='article-slider'] .holder").each(function () {
			$(this).attr('style', 'background-image: url( ' + $(this).data("mobile-background") + ' )');
		});
	}

	this.slider = function () {

		$('[data-component="article-slider"] .div-to-slide').slick({
			centerMode: true,
			slidesToShow: 1,
			centerPadding: '120px',
			responsive: [{
				breakpoint: 1024,
				settings: {
					centerPadding: '60px',
					arrows: false
				}
			}, {
				breakpoint: 768,
				settings: {
					centerPadding: '20px',
					arrows: false
				}
			}]
		});
	};

	return this.init();
};
'use strict';

var BankFeatures = function BankFeatures() {

	var comp = $('[data-component="bank-features"]');

	this.init = function () {

		if ($(window).width() > 1024) {

			comp.find('.card').stop().on('mouseenter', function (e) {
				comp.addClass('focus');
				comp.find('.card').addClass('less');
				$(this).removeClass('less').addClass('open');
			}).stop().on('mouseleave', function (e) {
				comp.removeClass('focus');
				$(this).removeClass('open');
				comp.find('.card').removeClass('less');
			});
		}
	};

	return this.init();
};
'use strict';

$(document).ready(function () {

	$('[data-component="banner-section"] a').on('mouseenter', function () {
		$(this).children('a i').attr('class', 'icon-arrow-right-white');
	}).on('mouseleave', function () {
		$(this).children('a i').attr('class', 'icon-arrow-right');
	});

	var imageMobile = $('.full-banner-holder').data('mobile-background');
	if ($(window).width() < 580) {
		$('.full-banner-holder').attr('style', 'background-image: url( ' + imageMobile + ' ); background-position: bottom right;');
	}
});
'use strict';

var Header = function Header() {

	var self = this;
	var $func;

	this.init = function () {

		if ($(window).width() <= 1024) {
			$func = 'click';
		} else {
			$func = 'mouseenter';
		}

		this.toggleLogin($func);

		this.toggleSubmenu($func);

		this.openMenu();

		this.focusLogin();

		//this.inputMask();

		this.closeMenu();

		//this.controlError();

		this.scrollMenu();

		this.alignAccount();
	};

	this.toggleSubmenu = function ($func) {
		$('[data-component="header"] .menu-list > li').stop().on($func, function (e) {
			e.stopPropagation();

			if ($(e.target).closest('.submenu').length < 1) {

				if ($(this).hasClass('menu-on')) {
					self.hideMenu();
					$(this).removeClass('menu-on');
				} else {
					self.hideMenu();

					$('.menu-on').removeClass('menu-on');
					$(this).addClass('menu-on');
					if ($(this).find('.submenu').length) {
						var submenu = $(this).find('.submenu');
						var submenuHeigth = submenu.outerHeight();

						submenu.show();

						$(this).find('.arrow').addClass('active');
						if ($(window).width() > 1024) {
							$('[data-component="header"] .header-left').addClass('submenu-active');

							TweenMax.to('[data-component="header"] .menu-list > li > a', '.3', { opacity: '.5', ease: Sine.easeOut });
							TweenMax.to($(this).find('.arrow'), '.3', { opacity: 1, ease: Sine.easeOut });
							TweenMax.to('[data-component="header"] .layer-submenu', '.7', { height: submenuHeigth, ease: Sine.easeOut });
							TweenMax.to(submenu, '.7', { delay: '.3', autoAlpha: 1, top: '10px', ease: Sine.easeOut });
						} else {

							var menuItem = $(this);
							var heightItem = submenuHeigth + $(this).outerHeight();

							TweenMax.to('[data-component="header"] .menu-list > li > a', '.3', { opacity: '.5', ease: Sine.easeOut });
							TweenMax.to($(this).find('.arrow'), '.3', { opacity: 1, ease: Sine.easeOut });
							TweenMax.to(menuItem, '.7', { height: heightItem + 20, ease: Sine.easeOut });
							TweenMax.to(submenu, '.7', { delay: '.3', autoAlpha: 1, top: 0, ease: Sine.easeOut });
						}
					}
				}
			}
		});

		$('[data-component="header"] .menu-list').stop().on('mouseleave', function (e) {
			self.hideMenu();
		});
	};

	this.hideMenu = function () {
		$('[data-component="header"] .menu-list a.arrow').removeClass('active');

		if ($(window).width() > 1024) {
			//$('[data-component="header"] .header-left').removeClass('submenu-active');

			TweenMax.to('[data-component="header"] .menu-list .submenu', '.2', { autoAlpha: 0, top: '-40%', ease: Sine.easeOut });
			TweenMax.to('[data-component="header"] .layer-submenu', '.4', { height: 0, ease: Sine.easeOut });
			TweenMax.to('[data-component="header"] .menu-list a', '.3', { opacity: 1, ease: Sine.easeOut });
		} else {
			TweenMax.to('[data-component="header"] .menu-list .submenu', '.3', { autoAlpha: 0, ease: Sine.easeOut });
			TweenMax.to('[data-component="header"] .menu-list a', '.3', { opacity: 1, ease: Sine.easeOut });
			TweenMax.to('[data-component="header"] .menu-list > li', '.3', { height: 50, ease: Sine.easeOut });
		}

		$('[data-component="header"] .menu-list .submenu').hide();
	};

	this.closeSubmenu = function () {
		$('[data-component="header"] .menu-list a.arrow').removeClass('active');
		if ($(window).width() > 1024) {
			$('[data-component="header"] .header-left').removeClass('submenu-active');

			TweenMax.to('[data-component="header"] .menu-list .submenu', '.2', { autoAlpha: 0, top: '-40%', ease: Sine.easeOut });
			TweenMax.to('[data-component="header"] .layer-submenu', '.4', { height: 0, ease: Sine.easeOut });
			TweenMax.to('[data-component="header"] .menu-list a', '.3', { opacity: 1, ease: Sine.easeOut });
		} else {
			TweenMax.to('[data-component="header"] .menu-list .submenu', '.3', { autoAlpha: 0, ease: Sine.easeOut });
			TweenMax.to('[data-component="header"] .menu-list a', '.3', { opacity: 1, ease: Sine.easeOut });
			TweenMax.to('[data-component="header"] .menu-list > li', '.3', { height: 50, ease: Sine.easeOut });
		}
	};
	/*this.inputMask = function(){
 	var options = {
 		onKeyPress: function (cpf, ev, el, op) {
 			var masks = ['000.000.000-000', '00.000.000/0000-00'],
 					mask = (cpf.length > 14) ? masks[1] : masks[0];
 			el.mask(mask, op);
 		}
 	};
 
 	$('[data-component="header"] .holder-input input').mask('000.000.000-000', options);
 };*/

	this.focusLogin = function () {

		$('[data-component="header"] .holder-input input').on('focus', function () {
			TweenMax.to('[data-component="header"] .holder-input', 0, { autoAlpha: 1, ease: Quint.easeIn });
		});

		$('[data-component="header"] .holder-input input').on('focusout', function () {
			TweenMax.to('[data-component="header"] .holder-input', 0, { autoAlpha: '.5', ease: Quint.easeOut });
		});
	};

	this.toggleLogin = function ($func) {

		$('[data-component="header"] .holder-login').on($func, function (e) {

			if (!$(e.target).hasClass('icon-white-arrow-down')) {
				TweenMax.to('[data-component="header"] .my-account-box span', '.5', { left: '150%', ease: Power3.easeOut });
				TweenMax.to('[data-component="header"] .my-account-box', '.5', { left: '100%', delay: '.3', ease: Power3.easeOut });
				TweenMax.to('[data-component="header"] .my-account-login', '.5', { right: 0, delay: '.3', ease: Power3.easeOut });

				if ($(window).width() < 768) {
					TweenMax.to("[data-component='header'] .header-right", .4, { 'height': '312px' });
				}

				$("[data-component='header'] .my-account-login").css({ 'height': '100%', 'top': '0' });
				$("[data-component='header'] .my-account-box").css({ 'height': '100%', 'top': '0' });
				$("[data-component='header'] .holder-login").css({ 'height': '100%', 'top': '0' });
			}
		});

		if ($(window).width() >= 1024) {
			$('[data-component="header"] .holder-login').on('mouseleave', function () {
				self.closeLogin();
			});
		} else {
			$('[data-component="header"] .holder-login .icon-white-arrow-down').on('click', function (e) {
				self.closeLogin();
			});
		}

		$("[data-component='header'] .my-account-login .icon-white-arrow-down").on('click', function () {
			self.closeLogin();
		});
	};

	this.closeLogin = function () {
		TweenMax.to('[data-component="header"] .my-account-box span', '.5', { left: '50%', ease: Power3.easeOut });
		TweenMax.to('[data-component="header"] .my-account-box', '.5', { left: 0, delay: '.3', ease: Power3.easeOut });
		TweenMax.to('[data-component="header"] .my-account-login', '.5', { right: '100%', delay: '.3', ease: Power3.easeOut });

		if ($(window).width() >= 1024) {
			// $("[data-component='header'] .my-account-login").css({'height': '60%','top': '36px'});
			// $("[data-component='header'] .my-account-box").css({'height': '60%','top': '36px'});
		} else {
			TweenMax.to("[data-component='header'] .header-right", .4, { 'height': '54px' });
		}

		$("[data-component='header'] .holder-login").css('height', '100%');
	};

	this.openMenu = function () {

		$('[data-component="header"] .mobile-menu').on('click', function () {
			TweenMax.to('[data-component="header"] .holder-menu', '.7', { width: '100%', ease: Power3.easeOut });
			TweenMax.to('[data-component="header"] .header-right', '.7', { width: '100%', ease: Power3.easeOut });
			TweenMax.to('[data-component="header"] .layer-menu', '.5', { autoAlpha: '.3', ease: Power3.easeOut });
			TweenMax.to('[data-component="header"] .close-menu', '1.2', { autoAlpha: 1, ease: Power3.easeOut });
			$('body').css("overflow", "hidden");
		});
		if ($(window).width() < 768) {
			$('[data-component="header"] .holder-login .my-account-box').on('click', function () {
				TweenMax.to('[data-component="header"] .holder-menu', '.7', { width: '100%', ease: Power3.easeOut });
				TweenMax.to('[data-component="header"] .header-right', '.7', { width: '100%', ease: Power3.easeOut });
			});
		}
	};

	this.closeMenu = function () {

		$('[data-component="header"] .close-menu').on('click', function () {
			TweenMax.to('[data-component="header"] .holder-menu', '.5', { width: 0, ease: Power3.easeOut });
			TweenMax.to('[data-component="header"] .header-right', '.5', { width: 0, ease: Power3.easeOut });
			TweenMax.to('[data-component="header"] .layer-menu', '.3', { autoAlpha: 0, ease: Power3.easeOut });
			TweenMax.to('[data-component="header"] .close-menu', '.5', { autoAlpha: 0, ease: Power3.easeOut });
			$('body').css("overflow", "auto");
		});
	};

	/*this.controlError = function(){
 
 	$('[data-component="header"] .icon-arrow-right').on('click', function() {
 
 		var length = $('[data-component="header"] .holder-input input').val().length;
 		var inputValue = $('[data-component="header"] .holder-input input').val();
 
 		if(length < 14) {
 			$('[data-component="header"] .error-layer .text').text('Preencha o campo corretamente.');
 			toTop();
 			error();
 		}
 		else if(length === 14 && ((inputValue) !== ('111.111.111-11'))) {
 			$('[data-component="header"] .error-layer .text').text('Não encontramos o seu usuário cadastrado. Por favor tente novamente ou cadastre-se/abra sua conta.');
 			toTop();
 			error();
 		}
 		else if(length > 14 && (inputValue !== ('11.111.111/1111-11'))){
 			$('[data-component="header"] .error-layer .text').text('Não encontramos sua empresa em nosso cadastro. Abra sua conta ou digite novamente.');
 			toTop();
 			error();
 		}
 		else {
 			$('[data-component="header"] .hidden').trigger('click');
 		}
 
 		$("html, body").on('click', function(e){
 			if(!$(e.target).is('.icon-arrow-right')){
 				toClose();
 			}
 		})
 
 	});
 
 	function error(){
 		$('[data-component="header"] #loginform input').addClass('error');
 		$('[data-component="header"] #loginform label').addClass('error');
 		$('[data-component="header"] #loginform label').text('Usuário inválido');
 	}
 
 
 	function toClose(){
 		TweenMax.to('[data-component="header"] .error-layer', '.1', { opacity:0, ease: Power4.easeOut});
 	}
 
 	function toTop(){
 		if($(window).width() > 768) {
 			TweenMax.to('[data-component="header"] .error-layer', '2', {autoAlpha: 1, top: '90%', opacity:1, ease: Power4.easeOut});
 		} else {
 			TweenMax.to('[data-component="header"] .error-layer', '2', {autoAlpha: 1, top: '-150%', opacity:1, ease: Power4.easeOut});
 		}
 	}
 
 };*/

	this.alignAccount = function () {
		if ($(window).width() > 1024) {
			// $('.main-link').next('.submenu-holder').find('li').css('margin-left', $('.main-link').position().left + 'px');
			$('.menu-list .arrow').each(function () {

				if ($(this).parent().find(".submenu-holder > .submenu > li").length > 0) {
					$(this).next('.submenu-holder').find('li').css('margin-left', $(this).position().left + 'px');
				}

				/*if($(this).text() == "Para você" || $(this).text() == "Abra sua conta" || $(this).text() == "Personal Banking") {
    	$(this).next('.submenu-holder').find('li').css('margin-left', $(this).position().left + 'px');
    }*/
			});
		}
	};

	this.scrollMenu = function () {
		var subHead = $('[data-component="subhead"]').css("display") === "none" ? true : false;
		var hideMenu = $(window).scrollTop();

		$(document).on('scroll', function () {
			var tamanhoAtual = $(window).scrollTop();
			if (tamanhoAtual < 10) {
				TweenMax.to('[data-component="header"]', 0.01, { css: { top: 0 } });
				//TweenMax.to($("body"), 0.7, {paddingTop: '120px'});
				if (!subHead) {
					TweenMax.to('[data-component="subhead"]', 0.01, { opacity: 1, visibility: "visible" });
				}
				hideMenu = tamanhoAtual;
			} else if (hideMenu < tamanhoAtual) {
				TweenMax.to('[data-component="header"]', 0.01, { css: { top: '-90px' } });
				//TweenMax.to($("body"), 0.01, {paddingTop: 0});
				if (!subHead) {
					TweenMax.to('[data-component="subhead"]', 0.01, { opacity: 0, visibility: "hidden" });
				}
				hideMenu = tamanhoAtual;
			} else {

				TweenMax.to('[data-component="header"]', 0.01, { css: { top: 0 } });
				//TweenMax.to($("body"), 0.7, {paddingTop: '120px'});
				if (!subHead) {
					TweenMax.to('[data-component="subhead"]', 0.01, { opacity: 1, visibility: "visible" });
				}
				hideMenu = tamanhoAtual;
			}
		});
	};
	return this.init();
};
'use strict';

var Highlights = function Highlights() {

	this.init = function () {

		this.equalizer();

		this.HighlightsSlider();
	};

	this.equalizer = function () {

		$(window).on('load', function () {

			if ($(window).width() > 767) {

				var height = $('.article .right').outerHeight();

				$('.article .img-holder').height(height);
			}
		});
	};

	$('[data-component="highlights"] .read-more').on('mouseenter', function () {
		$('.read-more i').attr('class', 'icon-arrow-right-black');
	}).on('mouseleave', function () {
		$('.read-more i').attr('class', 'icon-arrow-right');
	});

	this.HighlightsSlider = function () {

		$('[data-component="highlights"] .div-to-slide').slick({
			arrows: false,
			slidesToShow: 1,
			centerMode: true,
			centerPadding: '0px',
			responsive: [{
				breakpoint: 768,
				settings: {
					arrows: false,
					centerMode: true,
					centerPadding: '0px',
					infinite: false
				}
			}]
		});

		$('[data-component="highlights"] a[data-slide]').click(function (e) {
			e.preventDefault();
			var slideno = $(this).data('slide');
			$('[data-component="highlights"] .div-to-slide').slick('slickGoTo', slideno);
			$(this).siblings().removeClass("current");
			$(this).addClass("current");
		});

		$('.div-to-slide').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
			var slideNum = nextSlide;
			$('[data-component="pagination"] a').each(function () {
				var currentData = $(this).data('slide');
				if (currentData == slideNum) {
					$('[data-component="pagination"] a').removeClass('current');
					$(this).addClass('current');
				}
			});
		});
	};

	return this.init();
};
'use strict';

var HowToInvest = function HowToInvest() {

	this.init = function () {

		this.HighlightsSlider();
	};

	this.HighlightsSlider = function () {

		$('[data-component="how-to-invest"] .slider').slick({
			arrows: false,
			slidesToShow: 1,
			centerMode: true,
			centerPadding: '0px',
			responsive: [{
				breakpoint: 768,
				settings: {
					arrows: false,
					centerMode: true,
					centerPadding: '0px'
				}
			}]
		});

		$('[data-component="how-to-invest"] a[data-slide]').click(function (e) {
			e.preventDefault();
			var slideno = $(this).data('slide');
			$('[data-component="how-to-invest"] .slider').slick('slickGoTo', slideno);
			$(this).siblings().removeClass("current");
			$(this).addClass("current");
		});

		$('.slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
			var slideNum = nextSlide;
			$('[data-component="pagination"] a').each(function () {
				var currentData = $(this).data('slide');
				if (currentData == slideNum) {
					$('[data-component="pagination"] a').removeClass('current');
					$(this).addClass('current');
				}
			});
		});
	};

	return this.init();
};
'use strict';

$(document).ready(function () {

	$('[data-component="new-bank-features"] .btn').on('mouseenter', function () {
		$('.btn i').attr('class', 'icon-arrow-right');
	}).on('mouseleave', function () {
		$('.btn i').attr('class', 'icon-arrow-right-white');
	});
});
'use strict';

var News = function News() {

	this.init = function () {

		this.Slider();
	};

	this.Slider = function () {

		$('[data-component="news"] .div-to-slide').slick({
			arrows: false,
			slidesToShow: 1,
			centerMode: true,
			centerPadding: '0px',
			responsive: [{
				breakpoint: 768,
				settings: {
					arrows: false,
					centerMode: true,
					centerPadding: '0px'
				}
			}]
		});

		$('[data-component="news"] a[data-slide]').click(function (e) {
			e.preventDefault();
			var slideno = $(this).data('slide');
			$('[data-component="news"] .div-to-slide').slick('slickGoTo', slideno);
			$(this).siblings().removeClass("current");
			$(this).addClass("current");
		});

		$('.div-to-slide').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
			var slideNum = nextSlide;
			$('[data-component="pagination"] a').each(function () {
				var currentData = $(this).data('slide');
				if (currentData == slideNum) {
					$('[data-component="pagination"] a').removeClass('current');
					$(this).addClass('current');
				}
			});
		});
	};

	return this.init();
};
'use strict';

var Offices = function Offices() {

	var comp = $('[data-component="border-menu"]'),
	    states = $('[data-component="states"]'),
	    header = $('[data-component="header"]'),
	    $id;

	this.init = function () {

		this.links();
		this.select();

		if ($(window).width() <= 1024) {
			states.each(function () {
				if ($(this).data('id') == comp.find('.active').data('id')) {
					$(this).show();
				}
			});
		}
	};

	this.links = function () {

		comp.each(function () {

			$(this).find('a').on('click', function (e) {
				e.preventDefault();

				$id = $(this).data('id');
				$(this).closest(comp).find('a').removeClass('active');
				$(this).addClass('active');

				states.each(function () {
					if ($(this).data('id') == $id) {
						$('html, body').animate({
							scrollTop: $(this).offset().top - header.height()
						}, 700);
					}
				});
			});
		});
	};

	this.select = function () {

		$('.select').each(function () {
			$(this).find('span').text($(this).prev('.border').find('.active').text());
		});

		$('.select select').on('change', function () {
			$(this).prev('span').text($(this).find('option:selected').text());

			states.hide(200);

			states.each(function () {
				if ($(this).data('id') == comp.find('select option:selected').val()) {
					$(this).delay(201).show(300);
				}
			});
		});
	};

	return this.init();
};
'use strict';

var ReceiveEmail = function ReceiveEmail() {

	var comp = $('[data-component="receive-email"]');
	var $self = this;

	this.init = function () {

		comp.each(function () {

			var CurrentComponent = $(this);

			$(this).find('form').validate({
				ignore: '.ignore',
				errorPlacement: function errorPlacement() {
					return true;
				},
				rules: {
					email: {
						required: true,
						email: true
					}
				},
				submitHandler: function submitHandler(form) {

					$.ajax({
						type: "POST",
						url: "/umbraco/surface/Economist/Send",
						data: JSON.stringify({ "Email": CurrentComponent.find("input[name='email']").val(), "ComponentID": CurrentComponent.data("id") }),
						dataType: "json",
						async: true,
						contentType: "application/json; charset=utf-8",
						success: function success(response) {

							console.log("sucesso");
						},
						error: function error(e) {

							console.log("error");
						}
					});
				}
			});

			$self.showForm($(this));
			$self.focusInput($(this));
			$self.submitEmail($(this));
		});
	};

	this.showForm = function ($comp) {

		$comp.find('.button').on('click', function () {
			$(this).hide();
			$comp.find('form').show();
			$comp.find('form label').trigger('click');
		});
	};

	this.focusInput = function ($comp) {

		$comp.find('label').on('click', function () {
			$(this).addClass('focus');
			$(this).next('input').focus();
		});

		$comp.find('input').on('focus', function () {
			$comp.find('label').text('E-mail');
		}).on('blur', function () {
			if (!$(this).val()) {
				$comp.find('label').removeClass('focus').text('Digite seu E-mail');
			}
		});
	};

	this.submitEmail = function ($comp) {

		$comp.find('form').on('submit', function () {
			if ($(this).find('.error').length < 1) {
				$(this).find('.fieldset, button').hide();
				$comp.find('.success').show();
			}
		});
	};

	return this.init();
};
'use strict';

var Subhead = function Subhead() {

	var comp = $('[data-component="subhead"]');

	this.init = function () {

		this.openMenu();
	};

	this.openMenu = function () {

		comp.find('.arrow').on('click', function (e) {
			e.preventDefault();

			$(this).toggleClass('active');
			comp.find('.submenu').slideToggle(300);
		});
	};

	return this.init();
};
"use strict";
'use strict';

var TabsCommercial = function TabsCommercial() {

	this.init = function () {

		this.tabs();

		this.details();

		if ($(window).width() < 1025) {
			this.mobile();
		}
	};

	this.tabs = function () {

		$('.tabs li').on('click', function () {
			var tab_id = $(this).attr('data-tab');

			$('.tabs li').removeClass('current');
			$('.tab-content').removeClass('current');

			$(this).addClass('current');
			$("#" + tab_id).addClass('current');
		});
	};

	this.details = function () {

		$('.more').on('click', function () {

			$(this).find('.btn-more').toggleClass('less');
			$(this).next('.detail').slideToggle(300);
		});
	};

	this.mobile = function () {

		$('.head').on('click', function () {

			$(this).toggleClass('less');
			$(this).parent().find('.box').slideToggle(300);
		});
	};

	return this.init();
};
'use strict';

var BorderMenu = function BorderMenu() {

	var comp = $('[data-component="border-menu"]'),
	    states = $('[data-component="states"]'),
	    header = $('[data-component="header"]'),
	    $id;

	this.init = function () {

		this.links();
		this.select();
	};

	this.links = function () {

		comp.each(function () {

			$(this).find('a').on('click', function (e) {
				e.preventDefault();

				$id = $(this).data('id');
				$(this).closest(comp).find('a').removeClass('active');
				$(this).addClass('active');

				states.each(function () {
					if ($(this).data('id') == $id) {
						$('html, body').animate({
							scrollTop: $(this).offset().top - header.height()
						}, 700);
					}
				});
			});
		});
	};

	this.select = function () {

		$('.select').each(function () {
			$(this).find('span').text($(this).prev('.border').find('.active').text());
		});

		$('.select select').on('change', function () {
			$(this).prev('span').text($(this).find('option:selected').text());
		});
	};

	return this.init();
};
'use strict';

var FaqItem = function FaqItem() {

	this.init = function () {

		this.itemslide();
	};

	this.itemslide = function () {

		$('body').on('click', '.question', function () {
			$(this).toggleClass("open");

			$(this).next(".content").slideToggle();

			if ($(this).hasClass('open')) {
				$('html, body').animate({
					scrollTop: $(window).scrollTop() + $(this).scrollTop() + ($(this).next().find('p').height() + 25)
				});
			}
		});
	};
	return this.init();
};
'use strict';

var FaqOptions = function FaqOptions() {

	var comp = $("[data-component='faq-options']"),
	    header = $('[data-component="header"]');

	this.init = function () {

		this.activeItem();
	};

	this.activeItem = function () {

		comp.find('.img-holder').on('click', function (e) {
			e.preventDefault();
			comp.find('.item').removeClass('active');
			$(this).closest('.item').addClass('active');

			if ($(window).width() < 768) {
				$('html, body').animate({
					scrollTop: $('[data-component="faq-item"]').offset().top - header.height()
				}, 700);
			}
		});
	};

	return this.init();
};
'use strict';

var Form = function Form(form) {

	var comp = $('[data-component="form"]');
	var $self = form;

	this.init = function () {

		customValidate();

		$($self).validate({
			ignore: '.ignore',
			errorPlacement: function errorPlacement() {
				return true;
			},
			rules: {
				nome: {
					required: true
				},
				mail: {
					required: true,
					email: true
				},
				phone: {
					required: true
				},
				message: {
					required: true
				},
				document: {
					required: true
				},
				maturity: {
					required: true
				},
				hiddenRecaptcha: {
					required: function required() {
						if (grecaptcha.getResponse() == '') {
							return true;
						} else {
							return false;
						}
					}
				}
			},
			submitHandler: function submitHandler(form) {

				if ($(form).valid()) {

					if ($(form).attr('id') == 'complaint') {

						$(form).find("button").attr("disabled", true);

						var ContactComponent = $($self).data("id");
						var ContactData = {
							"Name": $($self).find("input[name='nome']").val(),
							"Email": $($self).find("input[name='mail']").val(),
							"Telephone": $($self).find("input[name='phone']").val(),
							"Message": $($self).find("textarea[name='message']").val()

							//Exibir uma loading gif?

						};$.ajax({
							type: "POST",
							url: "/umbraco/surface/ContactUs/Send",
							data: JSON.stringify({ "ContactData": ContactData, "ContactComponent": ContactComponent, "response": grecaptcha.getResponse() }),
							dataType: "json",
							async: true,
							contentType: "application/json; charset=utf-8",
							success: function success(response) {

								//resetar os campos ou apresentar mensagem de sucesso ou fazer animacao de formulario enviado
								//esconder a loading gif
								$('[data-component="modal-form"] .text').text('Mensagem enviada!');
								$(form).find('a.hidden')[0].click();
								$(form).trigger("reset");
								grecaptcha.reset();
								$(form).find("button").attr("disabled", false);
							},
							error: function error(e) {

								//se for necessário: exibir uma mensagem de erro personalizada
								//esconder a loading gif
								$('[data-component="modal-form"] .text').text('Erro ao enviar a mensagem!');
								$(form).find('a.hidden')[0].click();
								$(form).find("button").attr("disabled", false);
							}
						});
					}
				}
			}
		});
	};

	function customValidate() {

		var options = {
			onKeyPress: function onKeyPress(cpf, ev, el, op) {
				var masks = ['000.000.000-000', '00.000.000/0000-00'],
				    mask = cpf.length > 14 ? masks[1] : masks[0];
				el.mask(mask, op);
			}
		};

		$('.document').mask('000.000.000-000', options);

		$.validator.addMethod("cpf", function (value, element) {
			value = $.trim(value);

			value = value.replace('.', '');
			value = value.replace('.', '');
			cpf = value.replace('-', '');
			while (cpf.length < 11) {
				cpf = "0" + cpf;
			}var expReg = /^0+$|^1+$|^2+$|^3+$|^4+$|^5+$|^6+$|^7+$|^8+$|^9+$/;
			var a = [];
			var b = new Number();
			var c = 11;
			for (i = 0; i < 11; i++) {
				a[i] = cpf.charAt(i);
				if (i < 9) b += a[i] * --c;
			}
			if ((x = b % 11) < 2) {
				a[9] = 0;
			} else {
				a[9] = 11 - x;
			}
			b = 0;
			c = 11;
			for (y = 0; y < 10; y++) {
				b += a[y] * c--;
			}if ((x = b % 11) < 2) {
				a[10] = 0;
			} else {
				a[10] = 11 - x;
			}

			var retorno = true;
			if (cpf.charAt(9) != a[9] || cpf.charAt(10) != a[10] || cpf.match(expReg)) retorno = false;

			return this.optional(element) || retorno;
		});
	}

	return this.init();
};
'use strict';

var Gallery = function Gallery() {

	this.init = function () {

		this.slider();
	};

	this.slider = function () {

		$('[data-component="gallery"] .div-to-slide').slick({
			slidesToShow: 1,
			centerMode: true,
			arrows: false,
			variableWidth: true,
			responsive: [{
				breakpoint: 2000,
				settings: {
					arrows: true,
					variableWidth: true
				}
			}, {
				breakpoint: 768,
				settings: {
					arrows: false,
					variableWidth: false,
					centerPadding: '20px'
				}
			}]
		});
	};

	return this.init();
};
'use strict';

var MainSearch = function MainSearch() {

	var comp = $('[data-component="main-search"]');

	this.init = function () {

		this.search();
	};

	this.search = function () {

		$("body, html").find('.search').on('click', function () {
			$('body, html').animate({ scrollTop: 0 }, 300);
			$("body .layer").css('display', 'block');
			TweenMax.to($('.layer'), 1, { zIndex: 2500, autoAlpha: 1 });
			TweenMax.to(comp, 1, { top: 0, ease: Quint.easeOut, onComplete: scale });
		});

		comp.find('.close-search').on('click', function () {
			close();
		});

		function scale() {
			TweenMax.to(comp, .6, { scale: 1, ease: Quint.easeOut });
			comp.find('.holder, .close-search').addClass('appear');
			comp.find('.search-input').focus();
		}

		function close() {
			TweenMax.to(comp, .2, { scale: 0.8, onComplete: function onComplete() {
					TweenMax.to($('.layer'), 1, { zIndex: -1, autoAlpha: 0 });
					TweenMax.to(comp, 2, { top: '-250%' });
				} });
			comp.find('.search-input').val('');
			comp.find('.results-holder').find('.results').remove();
			comp.find('.results-holder').hide();
			comp.find('.holder, .close-search').removeClass('appear');
		}
	};

	return this.init();
};
'use strict';

var Message = function Message(form) {

    var comp = $('[data-component="message"]');
    var $self = form;

    this.init = function () {

        mask();

        this.validate();

        this.active();
    };

    function mask() {
        comp.find('#phone').mask('(00) 00000-0000');
    }

    this.validate = function () {

        $($self).validate({
            ignore: ".ignore",
            rules: {
                name: {
                    required: true
                },
                email: {
                    required: true,
                    email: true
                },
                message: {
                    required: true
                },
                opcoes: {
                    required: true
                },
                hiddenRecaptcha: {
                    required: function required() {
                        if (grecaptcha.getResponse() == '') {
                            return true;
                        } else {
                            return false;
                        }
                    }
                }
            },
            errorPlacement: function errorPlacement(error, element) {},
            submitHandler: function submitHandler(form) {

                if ($(form).valid()) {

                    $(form).find("button").attr("disabled", true);

                    var MessageComponent = $($self).data("id");

                    var MessageData = {
                        "Name": $($self).find("input[name='name']").val(),
                        "Email": $($self).find("input[name='email']").val(),
                        "Telephone": $($self).find("input[name='phone']").val(),
                        "Company": $($self).find("input[name='company']").val(),
                        "IsCustomer": $($self).find("input[name='opcoes']:checked").val(),
                        "Message": $($self).find("textarea[name='message']").val()

                        //Exibir uma loading gif?

                    };$.ajax({
                        type: "POST",
                        url: "/umbraco/surface/Message/Send",
                        data: JSON.stringify({ "MessageData": MessageData, "MessageComponent": MessageComponent, "response": grecaptcha.getResponse() }),
                        dataType: "json",
                        async: true,
                        contentType: "application/json; charset=utf-8",
                        success: function success(response) {

                            //resetar os campos ou apresentar mensagem de sucesso ou fazer animacao de formulario enviado
                            //esconder a loading gif
                            $('[data-component="modal-form"] .text').text('Mensagem enviada!');
                            $(form).find('a.hidden')[0].click();
                            $(form).trigger("reset");
                            grecaptcha.reset();
                            $(form).find("button").attr("disabled", false);
                        },
                        error: function error(e) {

                            //se for necessário: exibir uma mensagem de erro personalizada
                            //esconder a loading gif
                            $('[data-component="modal-form"] .text').text('Erro ao enviar a mensagem!');
                            $(form).find('a.hidden')[0].click();
                            $(form).find("button").attr("disabled", false);
                        }
                    });
                }
            }
        });
    };

    this.active = function () {

        $('.form-box input').on('focus', function () {
            TweenMax.to($(this).parent().find('.label-form'), .5, { scale: .8, top: -10 + 'px', transformOrigin: "left", ease: Back.easeOut });
        });

        $('.form-box input').on('focusout', function () {
            if ($(this).val() == '') {
                TweenMax.to($(this).parent().find('.label-form'), .5, { scale: 1, top: 0 + 'px', ease: Back.easeOut });
            };
        });
    };

    return this.init();
};
'use strict';

var Accounts = function Accounts() {

	var comp = $('[data-component="accounts"]');

	this.init = function () {

		activeAccount();
	};

	function activeAccount() {
		comp.find('.account').on('mouseenter', function () {
			$(this).addClass('focus');
		});
		comp.find('.account').on('mouseleave', function () {
			$('.account').removeClass('focus');
		});
		$("#login-type").mCustomScrollbar();
	}

	return this.init();
};
'use strict';

var Register = function Register() {

	var comp = $('[data-component="register"]');
	var aux;

	this.init = function () {

		mask();

		formValidate();

		if ($(window).width() < 768) {
			mobileModal();
		}
	};

	function mobileModal() {
		TweenMax.to(comp, 0.5, { css: { marginTop: '10px' } });
	}

	function mask() {
		comp.find('#cnpj').mask('00.000.000/0000-00', { reverse: true });
		comp.find('#cpf').mask('000.000.000-00', { reverse: true });
		comp.find('#phone').mask('(00) 00000-0000');
	}

	function formValidate() {

		$('#form-register-pj').validate({
			ignore: '.ignore',
			errorPlacement: function errorPlacement() {
				return true;
			},
			rules: {
				name: {
					required: true
				},
				email: {
					required: true,
					email: true
				},
				phone: {
					required: true
				},
				cnpj: {
					required: true
				}
			},
			submitHandler: function submitHandler(form) {

				if ($(form).valid()) {

					$(form).find("button").attr("disabled", true);

					var ComponentID = $(comp).data("id");
					var BankAccountData = {
						"Name": $(comp).find("input[name='name']").val(),
						"CNPJ": $(comp).find("input[name='cnpj']").val(),
						"Email": $(comp).find("input[name='email']").val(),
						"Telephone": $(comp).find("input[name='phone']").val()
					};

					$.ajax({
						type: "POST",
						url: "/umbraco/surface/Account/Send",
						data: JSON.stringify({ "BankAccountData": BankAccountData, "ComponentID": ComponentID }),
						dataType: "json",
						async: true,
						contentType: "application/json; charset=utf-8",
						success: function success(response) {

							$("[data-component='contact'] .text").text("Entraremos em contato com você!");
							$('.to-hidden').trigger('click');

							$(form).find("button").attr("disabled", false);
						},
						error: function error(e) {

							$("[data-component='contact'] .text").text('Erro ao enviar a mensagem!');
							$('.to-hidden').trigger('click');

							$(form).find("button").attr("disabled", false);
						}

					});
				}
			}
		});

		$('#form-register-pf').validate({
			ignore: '.ignore',
			errorPlacement: function errorPlacement() {
				return true;
			},
			rules: {
				name: {
					required: true
				},
				email: {
					required: true,
					email: true
				},
				cpf: {
					required: true
				},
				phone: {
					required: true
				},
				cnpj: {
					required: true
				}
			},
			submitHandler: function submitHandler(form) {}
		});
	}

	/*comp.find('.btn-finalize').on('click', function(e){
 	aux = $(this).closest('form').attr('id');
 	$('#'+aux).submit();
 	if($('#'+aux).find('.error').length < 1) {
 		$('.to-hidden').trigger('click');
 	}
 })*/

	return this.init();
};
'use strict';

var TableModal = function TableModal() {

	var comp = $('[data-component="table-modal"]');
	var compTable = $('[data-component="table"]');
	var html;
	var _self;

	this.init = function () {

		this.appendData();
	};

	this.appendData = function () {
		compTable.on('click', '[data-modal-id="table-modal"]', function (e) {
			$('.layer.to-modal').show();

			if ($(e.target).is("a")) {
				e.stopPropagation();
				return;
			}

			html = $(this).parent().html();

			var thead = $(this).closest("table").find("thead tr").html();

			html = html.split('data-modal-id="table-modal"').join('');

			comp.find(".first-table > thead").append(thead);
			comp.find('.to-add-content').prepend('<tr class="to-remove">' + html + '</tr>');

			_self = $(this);

			setTimeout(function () {
				_self.addClass('opened-modal');
				$('.layer.to-modal').hide();
			}, 1100);
		});

		$(document).on('click', '.close-modal, .modal-bg', function () {
			if (compTable.find('.opened-modal').length > 0) {
				comp.find(".first-table > thead").empty();
				comp.find(".overflow").scrollLeft(0);
				comp.find('.to-remove').remove();
				compTable.find('.opened-modal').removeClass('opened-modal');
			}
		});
	};

	return this.init();
};
'use strict';

var Ranking = function Ranking() {

	var comp = $('[data-component="ranking"]'),
	    menu,
	    table,
	    $id;

	this.init = function () {

		this.filter();
		this.select();

		if ($(window).width() <= 1024) {
			comp.each(function () {
				menu = $(this).find('[data-component="border-menu"]');
				table = $(this).find('[data-component="ranking-table"]');
				table.each(function () {
					if ($(this).data('id') == menu.find('.active').data('id')) {
						$(this).show();
					}
				});
			});
		}
	};

	this.filter = function () {

		comp.each(function () {
			menu = $(this).find('[data-component="border-menu"]');
			table = $(this).find('[data-component="ranking-table"]');

			menu.find('a').on('click', function (e) {
				e.preventDefault();

				$id = $(this).data('id');
				menu.find('a').removeClass('active');
				$(this).addClass('active');

				if ($id == 'all') {
					table.fadeIn(300);
				} else {
					table.each(function () {
						if ($(this).data('id') == $id) {
							$(this).fadeIn(300);
						} else {
							$(this).fadeOut(300);
						}
					});
				}
			});
		});
	};

	this.select = function () {

		comp.find('.select').each(function () {
			$(this).find('span').text($(this).prev('.border').find('.active').text());
		});

		comp.find('.select select').on('change', function () {
			$(this).prev('span').text($(this).find('option:selected').text());

			comp.each(function () {
				menu = $(this).find('[data-component="border-menu"]');
				table = $(this).find('[data-component="ranking-table"]');
				table.hide(200);
				table.each(function () {
					if ($(this).data('id') == comp.find('select option:selected').val()) {
						$(this).delay(201).show(300);
					}
				});
			});
		});
	};

	return this.init();
};
'use strict';

var Tabs = function Tabs() {

	this.init = function () {

		this.tabs();
	};

	this.tabs = function () {

		$('.tabs li').click(function () {
			if (!$(this).hasClass("tabLinkUrl")) {

				var tab_id = $(this).attr('data-tab');

				$('.tabs li').removeClass('current');
				$('.tab-content').removeClass('current');

				$(this).addClass('current');
				$("#" + tab_id).addClass('current');
			}
		});
	};

	return this.init();
};
'use strict';

var Transition = function Transition() {

	var comp = $('[data-component="transitions"]'),
	    menu,
	    cases,
	    $id;

	this.init = function () {

		this.filter();
		this.select();

		if ($(window).width() <= 1024) {
			comp.each(function () {
				menu = $(this).find('[data-component="border-menu"]');
				cases = $(this).find('[data-component="study"]');
				cases.each(function () {
					if ($(this).data('year') == menu.find('.active').data('id') || menu.find('.active').data('id') == 'all') {
						$(this).parent().show();
					}
				});
			});
		}
	};

	this.filter = function () {

		comp.each(function () {
			menu = $(this).find('[data-component="border-menu"]');
			cases = $(this).find('[data-component="study"]');

			menu.find('a').on('click', function (e) {
				e.preventDefault();

				$id = $(this).data('id');
				menu.find('a').removeClass('active');
				$(this).addClass('active');

				if ($id == 'Todos' || $id == 'all') {
					cases.parent('.col-xs-12').fadeIn(300);
				} else {
					cases.each(function () {
						if ($(this).data('year') == $id) {
							$(this).closest('.col-xs-12').fadeIn(300);
						} else {
							$(this).closest('.col-xs-12').fadeOut(300);
						}
					});
				}
			});
		});
	};

	this.select = function () {

		comp.find('.select').each(function () {
			$(this).find('span').text($(this).prev('.border').find('.active').text());
		});

		comp.find('.select select').on('change', function () {
			$(this).prev('span').text($(this).find('option:selected').text());

			comp.each(function () {
				menu = $(this).find('[data-component="border-menu"]');
				cases = $(this).find('[data-component="study"]');
				cases.parent().hide(200);
				cases.each(function () {
					if ($(this).data('year') == comp.find('select option:selected').val()) {
						$(this).parent().delay(201).show(300);
					} else if (comp.find('select option:selected').val() == 'all' || comp.find('select option:selected').val() == 'Todos') {
						$(this).parent().delay(201).show(300);
					}
				});
			});
		});
	};

	return this.init();
};
'use strict';

var Video = function Video() {
	var video, videoUrl, YTiframe;
	var player;
	var comp = $('[data-component="video"]');

	function init() {

		comp.each(function () {
			var comp = $(this);

			if (comp.hasClass('youtube')) {

				comp.find('.play').on('click', function () {
					YTiframe = comp.find('.youtube-iframe');
					video = YTiframe.attr('id');
					videoUrl = YTiframe.data('video');
					onYouTubeIframeAPIReady(video, videoUrl);
				});
			} else {

				comp.find('.play').on('click', function () {

					comp.find('video').addClass('appear');

					setTimeout(function () {
						var v = comp.find('video')[0];
						v.play();
					}, 100);
				});
			}
		});
	}

	function onYouTubeIframeAPIReady(video, url) {
		setTimeout(function () {
			player = new YT.Player(video, {
				videoId: url,
				events: {
					'onReady': onPlayerReady
				}
			});
		}, 1);
	}

	function onPlayerReady(event) {
		event.target.playVideo();
	}

	return init();
};
'use strict';

var HighlightCarrousel = function HighlightCarrousel() {

	var comp = $('[data-component="highlight-carrousel"]');

	this.init = function () {

		this.HighlightsSlider();
	};

	this.HighlightsSlider = function () {

		comp.find('.slider-holder').slick({
			arrows: false,
			slidesToShow: 1,
			centerMode: true,
			centerPadding: '400px',
			responsive: [{
				breakpoint: 2000,
				settings: {
					centerPadding: '300px'
				}
			}, {
				breakpoint: 1650,
				settings: {
					centerPadding: '200px'
				}
			}, {
				breakpoint: 1450,
				settings: {
					centerPadding: '150px'
				}
			}, {
				breakpoint: 1370,
				settings: {
					centerPadding: '100px'
				}
			}, {
				breakpoint: 1200,
				settings: {
					centerPadding: '75px'
				}
			}, {
				breakpoint: 1050,
				settings: {
					centerPadding: '50px'
				}
			}, {
				breakpoint: 992,
				settings: {
					centerPadding: '90px'
				}
			}, {
				breakpoint: 870,
				settings: {
					centerPadding: '50px'
				}
			}, {
				breakpoint: 768,
				settings: {
					centerPadding: '150px'
				}
			}, {
				breakpoint: 670,
				settings: {
					centerPadding: '120px'
				}
			}, {
				breakpoint: 610,
				settings: {
					centerPadding: '100px'
				}
			}, {
				breakpoint: 550,
				settings: {
					centerPadding: '80px'
				}
			}, {
				breakpoint: 500,
				settings: {
					centerPadding: '60px'
				}
			}, {
				breakpoint: 470,
				settings: {
					centerPadding: '40px'
				}
			}, {
				breakpoint: 415,
				settings: {
					centerPadding: '35px'
				}
			}, {
				breakpoint: 390,
				settings: {
					centerPadding: '30px'
				}
			}, {
				breakpoint: 370,
				settings: {
					centerPadding: '20px'
				}
			}, {
				breakpoint: 350,
				settings: {
					centerPadding: '10px'
				}
			}]
		});
	};

	return this.init();
};
'use strict';

var Graphics = function Graphics() {

	this.init = function () {

		this.graphics();
	};

	this.graphics = function () {

		google.charts.load('current', { 'packages': ['corechart'] });
		google.charts.setOnLoadCallback(drawChart);

		function drawChart() {

			var GraphicValue = {};
			var GraphicValueArray = [];

			$(".graphicValue").each(function () {

				GraphicValue = {
					"Name": $(this).data("name"),
					"Color": $(this).data("color"),
					"Value": $(this).data("value")
				};

				GraphicValueArray.push(GraphicValue);
			});

			var DataTableArray = [['Task', 'Hours per Day']];

			var OptionsColorsArray = [];

			for (var i = 0; i < GraphicValueArray.length; i++) {
				DataTableArray.push([GraphicValueArray[i].Name, GraphicValueArray[i].Value]);
				OptionsColorsArray.push(GraphicValueArray[i].Color);
			}

			var data = google.visualization.arrayToDataTable(DataTableArray);

			var options = {
				title: '',
				ignoreBounds: true,
				legend: { position: 'left', textStyle: { fontSize: 20, fontName: 'Gotham Narrow Book', color: '#5c6066' } },
				chartArea: {
					right: 130, // set this to adjust the legend width
					left: 60 // set this eventually, to adjust the left margin
				},
				colors: OptionsColorsArray,
				fontName: 'Gotham Narrow SSm Light',
				fontSize: 23
			};

			var chart = new google.visualization.PieChart(document.getElementById('piechart'));

			chart.draw(data, options);
		}
	};

	return this.init();
};
'use strict';

$(document).ready(function () {

	$('[data-component="opportunities-item"] .btn').on('mouseenter', function () {
		$('[data-component="opportunities-item"] .btn i').attr('class', 'icon-arrow-right-white');
	}).on('mouseleave', function () {
		$('[data-component="opportunities-item"] .btn i').attr('class', 'icon-arrow-right');
	});
});
'use strict';

var Timeline = function Timeline() {

	var total = 0;
	var $width = 0;

	this.init = function () {

		this.timeline();
	};

	this.timeline = function () {

		$('[data-component="timeline"]').find('.column').each(function () {

			$width = $(this).outerWidth();
			total = total + $width;
		});

		if ($(window).width() > 1024) {
			$('[data-component="timeline"] .holder').css('width', total + 50);
			$('.overflow').mCustomScrollbar({
				axis: "x"
			});
		}
	};

	return this.init();
};